import { IonIcon } from '@ionic/react';
import { print, trash } from 'ionicons/icons';
import MaterialTable from 'material-table';
import React from 'react'
import { Link } from 'react-router-dom';
import { APPLINKS } from '../../../resources/AppConst';
import tableIcons from '../../../resources/tableIcons';

const CustomerLedgerTable = ({ CustomerLedger, printVoucher, removeFromLedger, editable }) => {
        return (
            <MaterialTable title={'Ledger'} icons={tableIcons} options={{
                toolbar: false,
                pageSize: 10,
                pageSizeOptions: [10, 20, 50, 100],
                // padding: 'dense',
                actionsColumnIndex: -1,
                headerStyle: {
                    backgroundColor: '#989aa2',
                    color: '#FFF',
                },
                actionsCellStyle: {
                    // backgroundColor: '#989aa2',
                    width: '20%',
                    alignItems: 'center',
                    justifyContent: 'center',
                },

            }} columns={[
                { title: 'Date', field: 'date', type: 'date' },
                { title: 'Bill No', field: 'billNo', type: 'string',  render: item => (item.billNo && (<Link to={`${APPLINKS.invoice}/${item.billId}`}>{item.billNo}</Link>)) },
                { title: 'Debit', field: 'debit', type: 'currency', currencySetting: { currencyCode: 'INR' } },
                { title: 'Credit', field: 'credit', type: 'currency', currencySetting: { currencyCode: 'INR' } },
            ]} actions={[
                rowData => ({
                    icon: () => <IonIcon icon={print} />,
                    tooltip: 'Print Voucher',
                    onClick: (event, rowData) => {
                        printVoucher(rowData.date, rowData.credit);
                    },
                    hidden: !(rowData.credit > 0 && rowData.receivable < 0),
                }),
                {
                    icon: () => <IonIcon icon={trash} />,
                    tooltip: 'Delete',
                    onClick: (event, rowData) => {
                        removeFromLedger(rowData.id);
                    },
                    hidden: !editable
                }
            ]} data={CustomerLedger} />
        )
}

export default CustomerLedgerTable
